










































import {Component, Vue} from 'vue-property-decorator'
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import DialogTextField from "@/components/Dialog/parts/DialogTextField.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import ImageUploader from "@/components/UI/ImageUploader.vue";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import {Util} from "@/_global/utils";
import NameInputs from "@/components/UI/NameInputs.vue";

@Component({
    components: {
        NameInputs,
        DialogTextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
        ImageUploader,
    },
})
export default class AddCategoryDialog extends Vue {
    private categoryNames: { [language_code: string]: string } = {};
    private categoryImageUrl: string = "";

    private onChangeName(languageCode: string, name: string): void {
        Vue.set(this.categoryNames, languageCode, name);
    }

    private onChangeImage(value: string): void {
        this.categoryImageUrl = value;
    }

    private onDeleteImage(): void {
        this.categoryImageUrl = "";
    }

    get newCategory(): CMS.Category {
        const tmpId: number = Util.getTempId(CategoriesStore.all);
        const menuId: number = Number(this.$route.params['menuId']);
        return {
            id: tmpId,
            menu_id: menuId,
            image_url: this.categoryImageUrl,
            names: this.categoryNames
        }
    }
}
